import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#050505] text-white/40 py-12 px-4 text-center text-xs" data-id="element-46">
      <div className="max-w-4xl mx-auto space-y-6" data-id="element-47">
        <p className="max-w-2xl mx-auto leading-relaxed" data-id="element-48">
          Disclaimer: The sales figures and results discussed in this training
          are our personal results and in some cases the sales figures and
          results of previous or existing clients. Please understand these
          results are not typical. We are not implying you will duplicate them
          (or do anything for that matter).
        </p>
        <div className="flex items-center justify-center gap-6" data-id="element-49">
          <a href="#" className="hover:text-white transition-colors" data-id="element-50">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-51">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-52">
            Contact
          </a>
        </div>
        <p data-id="element-53">
          &copy; {new Date().getFullYear()} The AI Firewall. All rights
          reserved.
        </p>
      </div>
    </footer>;
};